import { ApiError } from "@/core/api/apiTypes";

export function isAuthenticationError(error: unknown): boolean {
  return error instanceof ApiError && error.Status === 401;
}
